<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h3 id="header-text" class="align-self-end pb-1">Vehicle Portfolio Report</h3>
  <div class="d-flex gap-8 pb-1 align-items-center">
    <button mat-flat-button color="primary" id="run-report-button" class="action-button"
            (click)="getPortfolioReport()"
            [disabled]="fcorgs.selectedOptions.length === 0">
      Run Report
    </button>
  </div>
</div>

<div class="d-flex flex-row gap-8">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label class="asterisk--before">Portfolio Type</mat-label>
    <mat-select [(ngModel)]="selectedPortType" id="port-type-select" (selectionChange)="onPortTypeChange()">
      <mat-option *ngFor="let portType of portTypes" [value]="portType">
        {{ portType.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="fcorg-filter" subscriptSizing="dynamic">
    <mat-label>Forecast Org</mat-label>
    <fab-multiselect
      [(ngModel)]="fcorgs.selectedOptions"
      [options]="fcorgs.options">
    </fab-multiselect>
  </mat-form-field>
  <mat-checkbox [(ngModel)]="multipleSheets" [disabled]="selectedPortType.id === 1">
    Multiple Tabs
  </mat-checkbox>
</div>
